import Vue from 'vue'
import VueRouter from 'vue-router'
import utils from '@storage/index.js'
import { Message } from 'element-ui'

Vue.use(VueRouter)

const router = new VueRouter({
  routes: (() => {
    return require(`./routes`).default
  })(),
})

// 路由有问题，则报出提示并且跳转回首页
function errorOperation(next) {
  Message({
    message: '出现了未知的错误，请刷新页面！',
    type: 'error',
    duration: 2000,
  })
  // 跳转到指定页面，这里假设是 NotFound 页面
  next({ name: 'homePage' })
}

// 全局前置守卫，可根据需要添加更多逻辑
router.beforeEach((to, from, next) => {
  if (to.name === 'chatPart') {
    let arr = utils.getLocalStorage('barList') || []
    if (to.params.id && arr.length !== 0 && arr.findIndex((e) => e.id === Number(to.params.id)) !== -1) {
      next()
    } else {
      errorOperation(next)
    }
  } else {
    next()
  }
})

export default router
